webpackJsonp([107818501498521],{

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(46);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _blogPostModule = __webpack_require__(341);
	
	var _blogPostModule2 = _interopRequireDefault(_blogPostModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	
	  return Glamor.createElement(
	    'div',
	    { className: _blogPostModule2.default.flex },
	    Glamor.createElement(_Header2.default, { color: 'black' }),
	    Glamor.createElement(
	      'div',
	      { className: _blogPostModule2.default.container },
	      Glamor.createElement(
	        'h1',
	        null,
	        post.frontmatter.title
	      ),
	      Glamor.createElement(
	        'h6',
	        { className: _blogPostModule2.default.date },
	        post.frontmatter.date
	      ),
	      Glamor.createElement('div', { dangerouslySetInnerHTML: { __html: post.html } })
	    ),
	    Glamor.createElement(_Footer2.default, { color: 'black' })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-templates----blog-post-module---container---3EKsY","flex":"src-templates----blog-post-module---flex---g2WK2","date":"src-templates----blog-post-module---date---3Uhz3"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-f175dbdc6fe400de3a34.js